import React from 'react';
import './App.css';
import CreditPanel from "./CreditPanel";
import LaunchpadPanel from "./LaunchpadPanel";
import TopBanner from "./TopBanner";

export default function Lobby() {
    return (
        <div className="App-header">
            <div className="MainPanel" style={{textAlign: "center", marginBottom: '10px'}}>
                <TopBanner/>

                <LaunchpadPanel collection='biznessmen' img='4mint/biznessmen-250.gif' title='The Biznessmen'
                           text ='Earn $BIZ in the biznessmen P2E game world by staking and completing missions.
                            Become elite for revshare. Launching soon!'/>

                <LaunchpadPanel collection='tractors' img='4mint/tractors-1.png' title='Tractors and Tanks'
                           text ='Support Ukraine by purchasing an NFT from this collection - all profits will be
                            donated to the Ukrainian army.'/>

                <LaunchpadPanel collection='gods' img='4mint/gods-1-200.png' title='Blockchain Gods'
                           text ='Play your God and earn $BLOOD in a revolutionary P2E game world.'/>

                <CreditPanel />

            </div>
        </div>
    );
}
